export default __webpack_public_path__ + "065bb1d737d9322297b4df739994a421.png";